export default __webpack_public_path__ + "static/media/check.297d72b7.svg";